import { FC } from 'react'
import { CardData } from '../../../type'
import { QRCode } from 'react-qrcode-logo'
import { ENV } from '../../../../../../Utils/_helpers/EnvHelper'
import { useResponsiveCard } from '../useResponsiveCard'
import './PreviewWalletCardApple.scss'
import { useI18n } from '../../../../../../Utils/_helpers/useI18n'
import { useLocation } from 'react-router-dom'

interface PreviewWalletCardAppleProps {
  cardData: CardData
  customStyles?: React.CSSProperties
}

export const PreviewWalletCardApple: FC<PreviewWalletCardAppleProps> = ({ cardData, customStyles = {} }) => {
  const isTemplate = useLocation().pathname.includes('card-templates')
  const qrCodeUrl = cardData.id && !isTemplate ? `${ENV().REACT_APP_FE_URL}/wallet-card/public/${cardData.id}` : `${ENV().REACT_APP_FE_URL}/dashboard`;
  const { width, height, fontSize, iconSize, qrSize } = useResponsiveCard();
  const logoSize = `calc(${iconSize} * 1.1)`;
  const { t } = useI18n()
  return (
    <div className="d-flex justify-content-center preview-wallet-card-apple">
      <div 
        className="card-container apple-card-container position-relative" 
        style={{ 
          width: width, 
          padding: `calc(${height} * 0.033)`, 
          fontSize: fontSize,
          ...customStyles,
          backgroundColor: cardData.backgroundColor
        }}
      >
        <div className="d-flex flex-column h-100">
          <div className="d-flex justify-content-between align-items-start mb-6 header-logo">
            <div>
              {cardData.logo ? (
                <img 
                  src={cardData.logo} 
                  alt="Company Logo" 
                  className="company-logo-apple" 
                  style={{ 
                    width: 60, 
                    height: 60
                  }} 
                />
              ) : null}
            </div>
            <div className="text-end website-container">
              <div className="fw-bold small text-uppercase" style={{ color: cardData.labelColor   }}>{t('WALLET_CARD.FORM.WEBSITE')}</div>
              <div className="small single-line-style" style={{ color: cardData.foregroundColor }}>{cardData.website}</div>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-start mb-6 header-logo">
            <div className="fullname-container col-8">
              <div className=" fw-bold small text-uppercase" style={{ color: cardData.labelColor }}>{t('WALLET_CARD.FORM.FULL_NAME')}</div>
              <div 
                className="fw-bold fullname-text single-line-style"
                style={{ color: cardData.foregroundColor }}
              >
                {cardData.fullName}
              </div>
            </div>
            {cardData.picture ? (
              <div className="profile-picture-container col-4" style={{ width: logoSize, height: logoSize }}>
                <img
                  src={cardData.picture}
                  alt="Profile"
                  className="profile-picture-img"
                />
              </div>
            ) : null}
          </div>
          
          {/* Email and Phone Section */}
          <div className="d-flex justify-content-between mb-6">
            <div className="w-50 me-2 header-content">
              <div className="fw-bold small text-uppercase" style={{ color: cardData.labelColor }}>{t('WALLET_CARD.FORM.EMAIL')}</div>
              <div className="small single-line-style" style={{ color: cardData.foregroundColor }}>{cardData.email}</div>
            </div>
            <div className="text-end w-50 header-content">
              <div className="fw-bold small text-uppercase" style={{ color: cardData.labelColor }}>{t('WALLET_CARD.FORM.PHONE')}</div>
              <div className="small single-line-style" style={{ color: cardData.foregroundColor }}>{cardData.phone}</div>
            </div>
          </div>

          {/* Address and Company Section */}
          <div className="d-flex justify-content-between mb-10">
            <div className="w-50 me-2">
              <div className="fw-bold small text-uppercase" style={{ color: cardData.labelColor }}>{t('WALLET_CARD.FORM.ADDRESS')}</div>
              <div className="small single-line-style" style={{ color: cardData.foregroundColor }}>{cardData.address}</div>
            </div>
            <div className="text-end w-50">
              <div className="fw-bold small text-uppercase" style={{ color: cardData.labelColor }}>{t('WALLET_CARD.FORM.COMPANY_NAME')}</div>
              <div className="small single-line-style" style={{ color: cardData.foregroundColor }}>{cardData.companyName}</div>
            </div>
          </div>

          {/* QR Code Section - Centered at bottom */}
          <div className="d-flex justify-content-center mt-4 mb-2">
            <div 
              className="qr-code-container my-10"
              style={{ 
                width: `calc(${qrSize} * 1.1)`, 
                height: `calc(${qrSize} * 1.1)`,
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                padding: '8px'
              }}
            >
              <QRCode
                size={qrSize}
                value={qrCodeUrl}
                fgColor="#000000"
                bgColor="#ffffff"
                ecLevel="M"
                removeQrCodeBehindLogo={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
